import axios from "axios";
import Vue from "vue";
import { getUrlParams } from "../utils/getUrlParams";

const request = axios.create({ withCredentials: true });

request.interceptors.request.use((config) => {
  if (config.method === "get") {
    const time = new Date().getTime();
    config.params = {
      _: time, // 添加时间戳，防止走缓存
      ...config.params,
    };
  }
  // 检查是否为免登录模式，如果是则 需要替换 sequelcenter 接口的域名
  if (
    Vue.prototype.$isLoginFree &&
    config.url &&
    config.url.includes("/sequelcenter")
  ) {
    // 替换路径
    config.url = config.url.replace(
      "api.xueersi.com/sequelcenter",
      "app.xesv5.com/sequelcenterapi"
    );
    const stuId = getUrlParams()?.stuId;
    if (stuId) {
      if (config.method === "post") {
        config.data = {
          ...config.data,
          stuId,
        };
      } else if (config.method === "get") {
        config.params = {
          ...config.params,
          stuId,
        };
      }
    }
  }

  return config;
});

const createRequest = (_request, options) =>
  new Promise((resolve, reject) => {
    const { needHeaders } = options;
    _request
      .then((res) => {
        const data = res.data;
        if (needHeaders) data.headers = res.headers;
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      });
  });

const methods = ["get", "post", "request"];

const net = { defaults: request.defaults };

for (const item of methods) {
  net[item] = (arg, ...args) => {
    let needHeaders = false;
    args.forEach((_item) => {
      if (_item) {
        if (_item.needHeaders) needHeaders = true;
      }
      return _item;
    });
    return createRequest(
      item === "request" ? request(arg, ...args) : request[item](arg, ...args),
      {
        needHeaders,
      }
    );
  };
}

export default net;
